module.exports = __webpack_public_path__ + "static/android-chrome-512x512-5b7e44dd4e3036824a68d8dcdc765b01.png";